import "../css/index.css";
import '@module/button-popup';
import '@module/video-player';
import '@module/smooth-scroll';
import Alpine from "alpinejs";
import API from "@module/API";
import Gallery from "@module/Gallery";
import initArchiveFilters from "@/filters/initArchiveFilters";
import initInjectableSvg from "@function/initInjectableSvg";
import setScrollbarWidth from "@function/setScrollbarWidth";
import { createPopupRoot, createPopupStore } from "@module/PopupController";
import { SelectPretty } from "@module/SelectPretty";
import { persistUTMValues } from "@module/UTM";
import './modules/formStore';

window.Alpine = Alpine;

Alpine.data('selectPretty', SelectPretty);
Alpine.data('popupRoot', createPopupRoot);
Alpine.store('popup', createPopupStore());
Alpine.start();

const client = new API({
    cache: {
        enabled: true,
    }
});

const initMarqueeAfterPageLoad = () => {
    if (!document.querySelector('.marquee-track')) {
        return;
    }

    const loadMarquee = () => {
        setTimeout(() => {
            import('@module/marquee').then(({ default: initMarquee }) => {
                initMarquee();
            });
        }, 2000);
    };

    if (document.readyState === 'complete') {
        loadMarquee();
    } else {
        window.addEventListener('load', loadMarquee, { once: true });
    }
};

// Delay swiper and Alpine initialization for better performance
setTimeout(() => {
    import('@module/swiper-init');
}, 2000);

const init = () => {
    // Persist UTM values on page load to ensure they are available for any subsequent API calls or form submissions
    persistUTMValues();

    initArchiveFilters(client);
    new Gallery();

    // Set scrollbar width CSS variable for better handling of scrollbars in the UI
    setScrollbarWidth();

    // Auto-select fill or stroke coloring so injected icons follow currentColor utilities
    initInjectableSvg();

    initMarqueeAfterPageLoad();
}

window.addEventListener('resize', setScrollbarWidth);

// Initialize modules when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        init();
    });
} else {
    init();
}
